/**
 * AGAPE XOXO BUNDLE PAGE - CHECKOUT REDIRECT & VARIANT DETECTION
 * Directs users to checkout immediately after adding bundle to cart
 * Detects products with variants and marks them for styling
 */

(function() {
  // Check if we're on bundle page or cart page
  var isBundlePage = document.querySelector('[ng-app="Bundler"]');
  var isCartPage = window.location.pathname === '/cart';

  // Detect products with variants and add data attribute
  function detectProductVariants() {
    var productCards = document.querySelectorAll('[dir-paginate*="product in products"]');

    productCards.forEach(function(card) {
      // Check if this product has multiple variants (more than 1)
      var variants = card.querySelector('[ng-init*="product.selectedVariant"]');
      if (variants) {
        // Get the number of variants from the product data
        var minusBtn = card.querySelector('.bdlr__product--qty-minus');
        var plusBtn = card.querySelector('.bdlr__product--qty-plus');

        // If both minus and plus buttons exist, this product has options
        if (minusBtn && plusBtn) {
          card.setAttribute('data-has-variants', 'true');
        }
      }
    });
  }

  // Check if cart contains svi_hidden product and redirect to checkout
  function checkCartForBundleAndRedirect() {
    // Fetch the cart data from Shopify
    fetch('/cart.json')
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        // Check if any item in cart has product type "svi_hidden"
        var hasBundleProduct = cart.items.some(function(item) {
          return item.product_type === 'svi_hidden';
        });

        // If bundle product found in cart, redirect to checkout
        if (hasBundleProduct) {
          window.location.replace(window.location.origin + '/checkout');
        }
      })
      .catch(function(error) {
        console.error('Error checking cart:', error);
      });
  }

  // Listen for cart changes and check if we should redirect
  function monitorCartChanges() {
    document.addEventListener('click', function(e) {
      var target = e.target;

      // Check if it's the main "Add to Cart" button from bundle
      // Supports both note and non-note checkout flows
      if (target.closest('#bdlr__summary-checkout--create-bundle') ||
          target.closest('.bdlr__checkout-button')) {

        // Add delay to allow bundling app to fully process and add items to cart
        // before checking and redirecting (3-4 seconds gives the app time to propagate)
        setTimeout(function() {
          checkCartForBundleAndRedirect();
        }, 3500);
      }
    });
  }

  // Initialize when DOM is ready
  function init() {
    // On bundle page: detect variants and monitor for cart changes
    if (isBundlePage) {
      detectProductVariants();
      monitorCartChanges();
    }

    // On cart page: check immediately if we should redirect
    if (isCartPage) {
      checkCartForBundleAndRedirect();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also check on page load for cart page users
  window.addEventListener('load', function() {
    if (isCartPage) {
      checkCartForBundleAndRedirect();
    }
  });
})();
